export interface WhatsAppCartItem {
    name: string;
    price: number;
    quantity: number;
    attributes?: { name: string; value: string }[];
}

function buildWhatsAppUrl(message: string, phone: string): string {
    const cleanPhone = phone.replace(/\D/g, "");
    const encoded = encodeURIComponent(message);
    return cleanPhone
        ? `https://wa.me/${cleanPhone}?text=${encoded}`
        : `https://wa.me/?text=${encoded}`;
}

export function buildCartWhatsAppUrl(items: WhatsAppCartItem[], phone?: string | null): string {
    const lines = items.map((item) => {
        const attrs = item.attributes?.length
            ? ` (${item.attributes.map((a) => `${a.name}: ${a.value}`).join(", ")})`
            : "";
        const subtotal = `$${(item.price * item.quantity).toLocaleString("es-AR")}`;
        return `• ${item.name}${attrs} x${item.quantity} - ${subtotal}`;
    });

    const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

    const message = [
        "Hola! Quisiera consultar el siguiente pedido:",
        "",
        ...lines,
        "",
        `Total estimado: $${total.toLocaleString("es-AR")}`,
        "",
        "Quedo atento/a a disponibilidad y mas informacion. Muchas gracias!",
    ].join("\n");

    return buildWhatsAppUrl(message, phone ?? "");
}

export function buildProductWhatsAppUrl(
    product: { nombre: string; sku: string },
    phone?: string | null,
): string {
    const message = [
        "Hola! Quisiera consultar por este producto:",
        "",
        `• ${product.nombre} (SKU: ${product.sku})`,
        "",
        "Muchas gracias!",
    ].join("\n");

    return buildWhatsAppUrl(message, phone ?? "");
}
